const translations = {
  en: {
    name: 'English',
    shortName: 'En',
    navbar: {
      language: 'Language'
    },
    routes: {
      about: 'About',
      blog: 'Blog'
    },
    forms: {
      buttons: {
        save: 'Save'
      }
    }
  },
  ru: {
    forms: {
      buttons: {
        save: 'Сохранить'
      }
    },
    name: 'Русский',
    shortName: 'Ру',
    navbar: {
      language: 'Язык'
    },
    routes: {
      about: 'Об авторе',
      blog: 'Блог'
    }
  }
}

export default translations



// WEBPACK FOOTER //
// ./src/translations.js